<script setup lang="ts">
import type { V1GetMinimalOptions } from "@gasparigit/omnia-sdk";
import { processError } from "~/lib/utils/errors";

const omniaSdk = useOmniaSdk();
const route = useRoute();
const contentId = useParamId();

const { data, error } = await useAsyncData(`content-${contentId}`, async () => {
  try {
    const params = {} as V1GetMinimalOptions & { date?: string };

    if (route.query.date) {
      params.date = route.query.date.toString();
    }

    return await omniaSdk.v1.contents.get(contentId, params);
  } catch (error) {
    processError(error);
  }
});

if (error.value) processError(error.value);
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title: data?.title }]" :search="false"></FrontBreadcrumHero>

  <FrontContentView v-if="data" :link-config="{}" v-model:content="data" />
  <Skeleton v-else class="main-content w-full h-52 rounded-lg mb-10" />
</template>
